
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class ItemProperties extends Vue {
  @Prop({ default: [] })
  properties: Object[]
}
